import { useRef } from "react";

/**
 * Подписанная ссылка, которая не меняется, пока смотрят одно и то же.
 *
 * Экран раз в 30 секунд и при каждом возврате в приложение перечитывает
 * задачи, и сервер всякий раз подписывает ссылку на видео заново — адрес
 * другой, хотя файл тот же. Плеер, получив новый `src`, начинает загрузку
 * сначала: ролик «спрыгивал на середине» и вставал (07.10.2026).
 *
 * Поэтому держим первую ссылку для ключа (версии ролика) и меняем её, только
 * когда сменился ключ или подпись подходит к концу: сервер подписывает на час,
 * а меняем через 40 минут, с запасом.
 */
const REFRESH_AFTER_MS = 40 * 60_000;

export function useStableUrl(key: string | undefined, url: string | undefined, now: () => number = Date.now): string | undefined {
  const held = useRef<{ key?: string; url?: string; at: number }>({ at: 0 });
  const h = held.current;
  const stale = now() - h.at > REFRESH_AFTER_MS;
  if (h.key !== key || !h.url || (stale && url && url !== h.url)) {
    held.current = { key, url, at: now() };
  }
  return held.current.url;
}
